import styled from "styled-components";
import NavBar from "../../../Componentes/NavBar";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";

import { useAmbienteMedicao } from "../../../contexts/AmbienteMedicaoContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useModal } from "../../../contexts/ModalContext";

import { FiFileText, FiPlus, FiSearch } from "react-icons/fi";
import { LuBanknote, LuChartNoAxesColumnIncreasing } from "react-icons/lu";
import { FaCheck } from "react-icons/fa6";
import SidebarPedidos from "./SidebarPedidos";
import ModalNovoPedido from "./ModalNovoPedido";
import useApi from "../../../hooks/useApi";
import { formatBRLFromCents } from "../../../Funcoes/Money";
import ModalNovoBM from "./ModalNovoBM";
import ModalEmailsBoletim from "./ModalEmailsBoletim";

const Container = styled.div`
    width: 100%;
    height: 100dvh;
    background-color: #242d34;
    display: flex;
    flex-direction: column;
`
const BodyWrapper = styled.div`
    width: 100%;
    flex: 1;
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    gap: 15px;
`
const TableWrapper = styled.div`
    width: 100%;
    flex: 1;
    background-color: #fff;
    border-radius: 15px;
    overflow: auto;
`
const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    color: #333;
    thead {
        background-color: #f0f0f0;
        position: sticky;
        top: 0;
        z-index: 2;
    }
    tbody {
        tr {
            border-bottom: 1px solid #ccc;
            // Adicionar linha sim e, linha não para melhor visualização
            &:nth-child(even) {
                background-color: #fafafa;
            }
            // Adicionar hover em azul claro
            &:hover {
                background-color: #e0f7fa;
            }
        }
    }
`
const LinhaCabecalho = styled.tr`
    height: 45px;
`
const ColunaCabecalho = styled.th`
    text-align: left;
    padding: 0 15px;
    color: #242d34;
    font-size: 15px;
`
const LogoWrapper = styled.div`
    background-color: #f0f0f0;
    width: 70px;
    height: 70px;
    margin-left: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    & img {
        max-width: 60px;
        max-height: 60px;
    }
`
const InfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    & p {
        margin: 0;
    }
    margin: 15px 0;
`
const ColunaAcoes = styled.td`
    width: 270px;
    padding: 0 50px 0 0;
    box-sizing: border-box;
`
const AcoesWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
`
const IconeWrapper = styled.div`
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
`
const Pendente = styled.div`
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
`
const IconeArquivo = styled(FiFileText)`
    color: #333;
    font-size: 30px;
    cursor: pointer;
    transition: .3s;
    &:hover {
        color: #007bff;
        transform: scale(1.1);
    }
`
const IconeAdicionar = styled(FiPlus)`
    color: ${props => props.disabled ? "#ccc" : "#333"};
    font-size: 30px;
    cursor: ${props => props.disabled ? "auto" : "pointer"};
    transition: .3s;
    &:hover {
        ${props => !props.disabled && "color: #007bff;"}
        transform: ${props => props.disabled ? "none" : "scale(1.1)"};
    }
`
const IconePesquisar = styled(FiSearch)`
    color: #333;
    font-size: 30px;
    cursor: pointer;
    transition: .3s;
    &:hover {
        color: #007bff;
        transform: scale(1.1);
    }
`
const IconeGrafico = styled(LuChartNoAxesColumnIncreasing)`
    color: ${props => props.disabled ? "#ccc" : "#333"};
    font-size: 30px;
    cursor: ${props => props.disabled ? "auto" : "pointer"};
    transition: .3s;
    &:hover {
        color: ${props => props.disabled ? "#ccc" : "#007bff"};
        transform: ${props => props.disabled ? "none" : "scale(1.1)"};
    }
`
const IconeFaturamentoDireto = styled(LuBanknote)`
    color: ${props => props.disabled ? "#ccc" : "#333"};
    font-size: 30px;
    cursor: ${props => props.disabled ? "auto" : "pointer"};
    transition: .3s;
    &:hover {
        color: ${props => props.disabled ? "#ccc" : "#007bff"};
        transform: ${props => props.disabled ? "none" : "scale(1.1)"};
    }
`
const LoadingContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`
const LoadingWrapper = styled.div`
    width: 350px;
    height: 120px;
    background-color: #f0f0f0;
    border-radius: 10px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
`
const SaldoFaturamento = styled.p`
    // Se o saldo for diferente de 0, mostrar em vermelho, caso contrário, mostrar em verde
    color: ${props => props.saldo !== 0 ? "red" : "green"};
`
const FiltersWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    height: 50px;
`
const IconeCheck = styled(FaCheck)`
    color: white;
    font-size: 16px;
`
const WrapperCheck = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    border-radius: 10px;
    background-color: #f0f0f0;
    padding: 0 15px;
    box-sizing: border-box;
    margin-right: 15px;
    cursor: pointer;
`
const WrapperCheckItem = styled.div`
    height: 30px;
    width: 30px;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 5px;
    margin-right: 10px;
    background-color: ${props => props.active ? "#007bff" : "transparent"};
    transition: .3s;
    ${WrapperCheck}:hover & {
        border-color: #007bff;
    }
    display: flex;
    align-items: center;
    justify-content: center;
`
const CheckText = styled.p`
    font-size: 14px;
    color: #333;
    margin: 0;
`
const FilterContainer = styled.div`
    height: 100%;
    flex: 1;
    display: flex;
    overflow: hidden;
    border-radius: 10px;
    background-color: #f0f0f0;
    border: 2px solid transparent;
    transition: .3s;
`
const FilterInput = styled.input`
    height: 100%;
    flex: 1;
    border: none;
    padding: 0 15px;
    box-sizing: border-box;
    font-size: 14px;
    outline: none;
    background-color: transparent;
`
const IconFilterWrapper = styled.div`
    width: 50px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`
const IconFilter = styled(FiSearch)`
    color: #333;
    font-size: 25px;
`

const PedidosCompra = () => {

    const { ambiente } = useAmbienteMedicao();
    const { isModalOpen, openModal, closeModal } = useModal();
    const api = useApi();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [pedidos, setPedidos] = useState([]);
    const [pedidosFilter, setPedidosFilter] = useState([]);

    useEffect(() => {

        if (!ambiente) {
            alert("Nenhum ambiente selecionado. Redirecionando para seleção de ambiente...");
            navigate("/modulo/controle-medicao");
        }

    }, [ambiente]);

    const handleOpenSidebar = () => {

        openModal("sidebarPedidosCompra");

    }

    const requestPedidos = async () => {

        setLoading(true);

        try {

            const { data } = await api.get("/Painel/API/ControleMedicao/PedidosCompra/index.php?obra=" + ambiente.id);

            setPedidos(data);
            setPedidosFilter(data);

        } catch (e) {

            console.error(e);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {

        requestPedidos();

    }, [])

    const openPedidoDetails = (pedidoId) => {

        navigate(`/modulo/controle-medicao/pedidos-compra/${pedidoId}`);

    }

    const openPreviewBoletim = (pedidoCompra) => {

        if (pedidoCompra.saldo_pedido === 0) {
            return;
        }

        navigate(`/modulo/controle-medicao/pedidos-compra/${pedidoCompra.id}/previsao-boletim`);

    }

    const totalFaturamentoDireto = (pedidoCompra) => {

        const base = Number(pedidoCompra?.valor_faturamento_direto) || 0;
        const adx = Number(pedidoCompra?.aditivos_direto) || 0;
        return base + adx;

    }

    const openDetalheFaturamentoDireto = (pedidoCompra) => {

        if (totalFaturamentoDireto(pedidoCompra) === 0) {
            return;
        }

        navigate(`/modulo/controle-medicao/pedidos-compra/${pedidoCompra.id}/faturamento_direto`);

    }

    const [pedidoCompraSelecionado, setPedidoCompraSelecionado] = useState(null);

    const openModalNovoBM = (pedidoCompra) => {

        if (pedidoCompra.saldo_pedido_prev !== 0 || pedidoCompra.saldo_pedido === 0) {
            return;
        }

        setPedidoCompraSelecionado(pedidoCompra);
        openModal("modalNovoBM")

    }

    const fecharModalNovoBM = () => {

        setPedidoCompraSelecionado(null);
        closeModal("modalNovoBM");

    }

    const viewBoletins = (id) => {

        navigate(`/modulo/controle-medicao/pedidos-compra/${id}/boletins`)

    }

    const [ pedidosComSaldo, setPedidosComSaldo] = useState(false);
    const [ filterName, setFilterName ] = useState("");

    //Criar filtro para mostrar apenas pedidos com saldo

    useEffect(() => {

        let filtered = [...pedidos];

        if (pedidosComSaldo) {
            filtered = filtered.filter(p => p.saldo_pedido > 0);
        }

        if (filterName) {
            filtered = filtered.filter(p => 
                p.num_pedido.toLowerCase().includes(filterName.toLowerCase()) ||
                p.nome_projeto.toLowerCase().includes(filterName.toLowerCase()) ||
                p.contratante.toLowerCase().includes(filterName.toLowerCase())
            );
        }

        setPedidosFilter(filtered);

    }, [ pedidosComSaldo, filterName ]);

    return (
        <Container>
            <NavBar goBackOnePage setSideBar={handleOpenSidebar} title="CONTROLE DE MEDIÇÕES" />
            <BodyWrapper>
                <FiltersWrapper>
                    <WrapperCheck
                        onClick={() => setPedidosComSaldo(!pedidosComSaldo)}
                    >
                        <WrapperCheckItem
                            active={ pedidosComSaldo }
                        >
                            { pedidosComSaldo && (
                                <IconeCheck />
                            )}
                        </WrapperCheckItem>
                        <CheckText>PEDIDOS COM SALDO</CheckText>
                    </WrapperCheck>
                    <FilterContainer>
                        <FilterInput
                            placeholder="PESQUISAR POR NÚMERO DO PEDIDO, PROJETO OU CONTRATANTE..."
                            value={filterName}
                            onChange={e => setFilterName(e.target.value)}
                        />
                        <IconFilterWrapper>
                            <IconFilter />
                        </IconFilterWrapper>
                    </FilterContainer>
                </FiltersWrapper>
                <TableWrapper>
                    {
                        loading ? (
                            <LoadingContainer>
                                <LoadingWrapper>
                                    <SmallLoading />
                                </LoadingWrapper>
                            </LoadingContainer>
                        ) : (
                            <Tabela>
                                <thead>
                                    <LinhaCabecalho>
                                        <ColunaCabecalho colSpan={4} >PEDIDOS DE COMPRA: {ambiente.descricao}</ColunaCabecalho>
                                    </LinhaCabecalho>
                                </thead>
                                <tbody>
                                    {
                                        pedidosFilter.map(p => {

                                            const can_add_bm = p.saldo_pedido_prev === 0;
                                            const saldo_zero = p.saldo_pedido === 0;
                                            const totalFatDir = totalFaturamentoDireto(p);
                                            const sem_fat_direto = totalFatDir === 0;

                                            return (
                                                <tr key={p.id}>
                                                    <td>
                                                        <LogoWrapper>
                                                            <img src='https://www.raizen.com.br/img/frontend/header/logo_green.svg' />
                                                        </LogoWrapper>
                                                    </td>
                                                    <td>
                                                        <InfoWrapper>
                                                            <p><b>PROJETO:</b> {p.nome_projeto}</p>
                                                            <p><b>PC N:</b> {p.num_pedido}</p>
                                                            <p><b>VALOR TOTAL:</b> {formatBRLFromCents(p.valor_faturamento + p.aditivos)}</p>
                                                            <p><b>FATURAMENTO DIRETO:</b> {formatBRLFromCents(totalFatDir)}</p>
                                                            <SaldoFaturamento saldo={p.saldo_pedido}><b>SALDO DO PEDIDO: {formatBRLFromCents(p.saldo_pedido)}</b></SaldoFaturamento>
                                                        </InfoWrapper>
                                                    </td>
                                                    <td>
                                                        <InfoWrapper>
                                                            <p><b>CONTRATANTE:</b> {p.contratante}</p>
                                                            <p><b>TIPO CONTRATO:</b> PRINCIPAL</p>
                                                        </InfoWrapper>
                                                    </td>
                                                    <ColunaAcoes>
                                                        <AcoesWrapper>
                                                            <IconeWrapper>
                                                                <IconeArquivo
                                                                    onClick={() => openPedidoDetails(p.id)}
                                                                />
                                                            </IconeWrapper>
                                                            <IconeWrapper>
                                                                <IconeAdicionar
                                                                    onClick={() => openModalNovoBM(p)}
                                                                    disabled={!can_add_bm || saldo_zero}
                                                                />
                                                            </IconeWrapper>
                                                            <IconeWrapper>
                                                                <IconePesquisar
                                                                    onClick={() => viewBoletins(p.id)}
                                                                />
                                                            </IconeWrapper>
                                                            <IconeWrapper>
                                                                <IconeGrafico
                                                                    onClick={() => openPreviewBoletim(p)}
                                                                    disabled={saldo_zero}
                                                                />
                                                                {
                                                                    !can_add_bm && (
                                                                        <Pendente />
                                                                    )
                                                                }
                                                            </IconeWrapper>
                                                            <IconeWrapper>
                                                                <IconeFaturamentoDireto
                                                                    title="Faturamento direto"
                                                                    onClick={() => openDetalheFaturamentoDireto(p)}
                                                                    disabled={sem_fat_direto}
                                                                />
                                                            </IconeWrapper>
                                                        </AcoesWrapper>
                                                    </ColunaAcoes>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Tabela>
                        )
                    }
                </TableWrapper>
            </BodyWrapper>
            {
                isModalOpen("sidebarPedidosCompra") && (
                    <SidebarPedidos />
                )
            }
            {
                isModalOpen("modalNovoPedidoCompra") && (
                    <ModalNovoPedido
                        onPedidoCreated={requestPedidos}
                    />
                )
            }
            {
                isModalOpen("modalNovoBM") && (
                    <ModalNovoBM
                        pedidoCompra={pedidoCompraSelecionado}
                        fecharModal={fecharModalNovoBM}
                    />
                )
            }
            {
                isModalOpen("modalEmailsBoletim") && (
                    <ModalEmailsBoletim />
                )
            }
        </Container>
    )
}

export default PedidosCompra;